import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import { Translation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import {
  getCustomerById,
  addNewCustomerInvoice,
  warnCustomerToDelete,
  setCustomerFormReadOnly,
  showInvoiceFormDialog
} from '../../actions/index'
import FontAwesome from 'react-fontawesome'

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    boxSizing: 'border-box'
  },
  tableRowHover: {
    position: 'relative',
    boxSizing: 'border-box',
    '&:hover': {
      border: '3px solid #44c0cc'
    }
  }
})

const CustomerRow = ({
  index,
  customer_id,
  companyName,
  contactPersonName,
  contactPersonEmail,
  address,
  zipCode,
  city,
  classes
}) => {
  const dispatch = useDispatch()

  const handleEditCustomer = (id) => {
    dispatch(setCustomerFormReadOnly(false))
    dispatch(getCustomerById(id))
  }

  const handleRowClick = (e) => {
    if (e.target.closest('.action-icon')) {
      return
    }
    dispatch(setCustomerFormReadOnly(true))
    dispatch(getCustomerById(customer_id))
  }

  return (
    <Translation>
      {(t) => (
        <TableRow
          key={customer_id}
          style={
            index % 2 ? { background: 'white' } : { background: '#ebf9fa' }
          }
          onClick={handleRowClick}
          className={classes.tableRowHover}
        >
          <TableCell component="th" scope="row" className={classes.tablecell}>
            {companyName}
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classNames(classes.tablecell, 'hide-mobile')}
          >
            {contactPersonName}
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classNames(classes.tablecell, 'hide-mobile')}
          >
            {contactPersonEmail}
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classNames(classes.tablecell, 'hide-mobile')}
          >
            {`${address}\n${zipCode} ${city.toUpperCase()}`}
          </TableCell>
          <TableCell component="th" scope="row" className={classes.tablecell}>
            <div style={{ display: 'flex' }}>
              <p
                style={{ marginLeft: '10px', marginRight: '15px' }}
                className="link action-icon"
                onClick={(e) => {
                  e.stopPropagation()
                  handleEditCustomer(customer_id)
                }}
              >
                <FontAwesome
                  title={t('iconTitle.editCustomer')}
                  name="pencil"
                />
              </p>
              <p
                style={{ marginLeft: '10px', marginRight: '15px' }}
                className="link action-icon"
                onClick={(e) => {
                  e.stopPropagation()
                  dispatch(warnCustomerToDelete(customer_id))
                }}
              >
                <FontAwesome
                  title={t('iconTitle.deleteCustomer')}
                  name="window-close"
                  style={{ color: '#F67131' }}
                />
              </p>
              <Link
                to="/dashboard/invoice"
                style={{ paddingRight: '15px' }}
                onClick={(e) => {
                  e.stopPropagation()
                  dispatch(addNewCustomerInvoice(customer_id))
                  dispatch(showInvoiceFormDialog())
                }}
              >
                <p style={{ marginLeft: '10px' }}>
                  <FontAwesome title={t('iconTitle.addInvoice')} name="plus" />
                </p>
              </Link>
            </div>
          </TableCell>
        </TableRow>
      )}
    </Translation>
  )
}

CustomerRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(CustomerRow)
